import { UseFormReturn } from 'react-hook-form';
import { commonStrings } from '@/services/translation/commonTranslations';

enum BEFieldValidation {
  EmailInUse = 'Email already in use',
  PhoneInUse = 'Phone Number already in use'
}

interface BEValidationReason {
  reason: string;
}

interface BEEmailValidationErr extends BEValidationReason {
  email: string;
}

interface BEPhoneValidationErr extends BEValidationReason {
  phoneNumber: string;
}

const extractBEError = (errorParent: string[], methods: UseFormReturn<any>) => {
  let errorObj: BEEmailValidationErr | BEPhoneValidationErr = JSON.parse(errorParent[0].replaceAll("'", '"'));

  if (errorObj.reason.includes(BEFieldValidation.EmailInUse)) {
    methods.setError('email', {
      message: commonStrings.common.toastNotifications.repeatEmail,
      type: 'BEValidation'
    });
  } else if (errorObj.reason.includes(BEFieldValidation.PhoneInUse)) {
    methods.setError('phoneNumber', {
      message: commonStrings.common.toastNotifications.repeatPhone,
      type: 'BEValidation'
    });
  }
};

export const handleBEFormError = (error: any, methods: UseFormReturn<any>) => {
  let emailErr: string[] | undefined = undefined;
  let phoneErr: string[] | undefined = undefined;

  try {
    let { InvalidEmail } = JSON.parse(error.graphQLErrors[0].message);
    emailErr = InvalidEmail;
  } catch (e) {
    //Catch parse error but continue
  }

  try {
    let { InvalidPhoneNumber } = JSON.parse(error.graphQLErrors[0].message);
    phoneErr = InvalidPhoneNumber;
  } catch (e) {
    //Catch parse error but continue
  }

  emailErr && extractBEError(emailErr, methods);
  phoneErr && extractBEError(phoneErr, methods);
};
